import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';
import { parseISO, addDays } from 'date-fns'
import { da, de, enGB, es, fi, fr, it, nl, pt, sv } from 'date-fns/locale';
import { toZonedTime, format } from 'date-fns-tz'
import { IonModal, IonDatetime } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'datetime-button',
  templateUrl: './datetime-button.component.html',
  styleUrls: ['./datetime-button.component.scss'],
  imports: [CommonModule, IonicModule, TranslateModule],
  standalone: true,
})
export class DatetimeButtonComponent  implements OnInit {

  @ViewChild('modal', { static: false }) modal!: IonModal;
  @ViewChild('datetime', { static: false }) datetime!: IonDatetime;
  @ViewChild('datetime', { static: false }) datetimeRef!: ElementRef;

  id: string = '';
  years: number[] = []
  year: number = 2000
  isFreeze: Boolean = false;
  buttonLabel: string = ''
  valueInitial: string | null = null;

  //Emit when the user validate a new date
  @Output() ionChange = new EventEmitter<void>();

  //Label when the date is undefined/empty
  @Input() labelEmpty: string | null = null;

  //same value than the ion-datetime presentation
  @Input() presentation: string = 'date';
  //same value than the button fill
  @Input() buttonFill: string = 'solid';
  //date or dateWithDay
  @Input() buttonLabelFormat: string = 'date';
  //embedded or not
  _isEmbed: boolean = false;
  @Input() set isEmbed(isEmbed: boolean) {
    this._isEmbed = false;
    this.setCSS();
  }
  get isEmbed(): boolean {
    return this._isEmbed;
  }

  //the title of the modal
  @Input() title: string | null = null;
  //the text of the button which valid the new date
  @Input() doneText: string | null = null;
  //the text of the button which cancel the change
  @Input() cancelText: string | null = null;
  //The maximum date, format yyyy-mm-dd
  @Input() max: string = '2050-12-31';
  //The minimum date, format yyyy-mm-dd
  @Input() min: string = '1940-01-01';

  //The maximum height of the input 
  @Input() maxHeight: string | null = null;

  _value: string | null = null;
  //Set the date, old form working with date-fns.parseISO
  @Input() set value(value: string | null) {
    //Si la date inclue l'heure, il faut arrondir au quart d'heure
    if(value?.includes('T')) {
      let date = this.dateFromString(value) ?? new Date()
      const roundedMinutes = Math.round(date.getMinutes() / 15) * 15;
      date.setMinutes(roundedMinutes);
      value = this.dateToStringIso(date)
    }

    if(!this.isFreeze && value != null && value != '') {
      this.valueInitial = value;
      this.selectBtYearCB(this.dateFromString(value)?.getFullYear() ?? 2000);
    }

    if(value == null) {
      this.buttonLabel = this.labelEmpty ? this.labelEmpty : this.translate.instant('Undefined')
    } else if(this.presentation == 'date-time') {
      this.buttonLabel = this.dateToStringShortWithTimeWithDay(this.dateFromString(value));
    } else if(this.presentation == 'week') {
      this.buttonLabel = this.translate.instant('Week') + ' ' + this.dateToStringShortWithoutTimeWithDay(this.dateFromString(value));
    } else if(this.presentation == 'month') {
      this.buttonLabel = this.dateToStringMonthYear(this.dateFromString(value));
    } else if(this.buttonLabelFormat == 'date') {
      this.buttonLabel = this.dateToStringShortWithoutTimeWithDay(this.dateFromString(value));
    } else if(this.buttonLabelFormat == 'dateOnlyNumbers') {
      this.buttonLabel = this.dateToStringShortWithoutTime(this.dateFromString(value));
    } else if(this.buttonLabelFormat == 'dateWithDay') {
      this.buttonLabel = this.dateToStringWithoutTimeWithDay(this.dateFromString(value));
    }

    if(value == null || value == '')
      value = this.dateToStringIso(new Date())
    this._value = value;

    this.updateYears();
    this.cdref.detectChanges();

    this.setCSS();
  }

  //get the date
  get value(): string | null {
    return this._value;
  }

  constructor(
    private cdref: ChangeDetectorRef,
    private translate: TranslateService) { 
    this.id = this.uuidv4()
  }

  ngOnInit() {
  }

  //populate the list of availables year
  updateYears() {
    if(!this.isEmbed) {
      this.years = []
      var max: number = 2050;
      if (this.max != null) {
        max = this.dateFromString(this.max)?.getFullYear() ?? 2050;
      }

      var min = 1940;
      if (this.min != null) {
        min = this.dateFromString(this.min)?.getFullYear() ?? 1940;
      }

      for(var i = min; i <= max; i++) {
        this.years.push(i)
      }
    }
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return 'i' + v.toString(16);
    });
  }

  //Hack some CSS of ion-datetime
  setCSS() {
    if(!this.isEmbed) {
      if(document.querySelector("#" + this.id.replaceAll('-', '\\-')) != null) {
        document.querySelector("#" + this.id.replaceAll('-', '\\-'))?.shadowRoot?.append(
          Object.assign(document.createElement("STYLE"),{ innerText : 'div.calendar-month-year { pointer-events: none; } div.datetime-calendar { max-width: 270px; }' }));
      }

      var elt = document.querySelector("#" + this.id.replaceAll('-', '\\-'))
      if(elt != null) {
        var elt2 = elt.shadowRoot?.querySelector<HTMLElement>('slot[name="time-label"]')
        if(elt2 != null)
          elt2.innerHTML = this.translate.instant('Time');

        elt2 = elt.shadowRoot?.querySelector<HTMLElement>('div.calendar-body')
        if(elt2 != null) {
          elt2.style.opacity = '1'
        }

        elt2 = elt.shadowRoot?.querySelector<HTMLElement>('div.calendar-month-year > ion-item > ion-label > ion-icon')
        if(elt2 != null) {
          elt2.remove();
        }
      }
    } else {
      let elts = document.querySelectorAll<HTMLElement>("#" + this.id.replaceAll('-', '\\-'))
      elts.forEach(elt => {

        let elts2 = elt.shadowRoot?.querySelectorAll<HTMLElement>('ion-picker')
        if(elts2 && elts2?.length > 0) {
          elts2.forEach(elt2 => {
            let elts3 = elt2.querySelectorAll<HTMLElement>('ion-picker-column')
            elts3.forEach(elt3 => {
              let elt4 = elt3.shadowRoot?.querySelector<HTMLElement>('div.picker-opts')
              if(elt4) {
                elt4.style.paddingInlineStart = '8px'
                elt4.style.paddingInlineEnd = '8px'
              }
            });


            elt2.style.maxHeight = '100px'
            elt.style.height = 'initial';
            elt.style.visibility = 'initial';

            let elt4 = elt2.shadowRoot?.querySelector<HTMLElement>('div.picker-highlight')
            if(elt4) {
              elt4.style.paddingInlineStart = '0px'
              elt4.style.paddingInlineEnd = '0px'
              elt4.style.width = '100%';
            }
          })
        } else {
          setTimeout(() => {
            this.setCSS();
          }, 30);
        }
      })
    }
  }

  //Execute by ion-datetime when the date change
  datetimeIonChange(event: any) {
    if(!this.isFreeze) {
      //On arrondis à la date du lundi de la semaine
      if(this.presentation == 'week') {
        var date = this.dateFromString(event.detail.value);
        if(date) {
          date.setDate(date.getDate() - date.getDay() + 1);
          event.detail.value = this.dateToStringIso(date);
        }
      }

      //On arrondis à la date au1er du mois
      if(this.presentation == 'month') {
        var date = this.dateFromString(event.detail.value);
        if(date) {
          date = addDays(date, -date.getDate() + 1)
          event.detail.value = this.dateToStringIso(date);
        }
      }

      this.ionChange.emit(event);

      if(!this.isEmbed) {
        this.modal.dismiss();
      }
      this.cdref.detectChanges();
    }
  }

  //The user select a year
  selectBtYearCB(year: number) {
    this.year = year;
    var elt = document.querySelector("#" + this.id.replaceAll('-', '\\-'))
    if(elt != null) {
      if(this.presentation == 'month') {
        elt = elt?.shadowRoot?.querySelector('ion-picker-column-internal') ?? null
        elt = elt?.shadowRoot?.querySelector('button[part="wheel-item active"]') ?? null
        if(elt) {
          var date: Date = new Date(this.year, Number(elt.getAttribute('data-value')) - 1, 1);
          if(date != null) {
            this.isFreeze = true;
            this.value = this.dateToStringIso(date);
            this.isFreeze = false;
            this.datetime.reset(this.value);
          }
        }
      } else {
        elt = elt?.shadowRoot?.querySelector('button[aria-selected="true"]') ?? null
        if(elt != null) {
          var date: Date = new Date(this.year, Number(elt.getAttribute('data-month')) - 1, Number(elt.getAttribute('data-day')));
          if(date != null) {
            this.isFreeze = true;
            this.value = this.dateToStringIso(date);
            this.isFreeze = false;
            this.datetime.reset(this.value);
          }
        } else {
          var currentDate: Date = this.dateFromString(this.value ?? '') ?? new Date()
          var date: Date = new Date(this.year, currentDate.getMonth(), currentDate.getDay());
          if(date != null) {
            this.isFreeze = true;
            this.value = this.dateToStringIso(date);
            this.isFreeze = false;
            this.datetime.reset(this.value);
          }
        }
      }
    }
  }

  //Execute when the modal is open
  showCalendarCB() {
    if(this.title == null) {
      this.title = this.translate.instant('Select a date')
    }
    
    var myElement = document.getElementById(this.id + '__item__' + this.year);
    if(myElement != null) {
      var topPos = myElement.offsetTop;
      var elt = document.getElementById(this.id + '__items')
      if(elt)
        elt.scrollTop = topPos - 100;
    }
    this.datetime.reset(this.value ?? '');
    this.setCSS();
  }

  showWillCalendarCB() {
  }

  hideCalendarCB() {
  }

  //Open the modal
  buttonClickCB() {
    this.present();
  }

  //The user cancel the change
  datetimeIonCancel(event: any) {
    this.value = this.valueInitial ?? '';
  }

  //Open the modal
  present() {
    setTimeout(() => {
      this.modal.present();
      setTimeout(() => {
        this.showCalendarCB();
      }, 5);
    }, 5);
  }


  dateFromString(date: string): Date | null {
    return date ? toZonedTime(parseISO(date), Intl.DateTimeFormat().resolvedOptions().timeZone): null;
  }

  dateToStringShortWithTimeWithDay(date: Date | null, locale = fr): string {
    if(date == null)
      return '';
    return format(date, 'd LLL yyyy HH:mm', {locale: this.dateGetLocale(this.translate.currentLang)});
  }

  dateToStringShortWithoutTime(date: Date | null, locale = fr): string {
    if(date == null)
      return '';
    return format(date, 'dd/MM/yyyy', {locale: this.dateGetLocale(this.translate.currentLang)});
  }

  dateToStringShortWithoutTimeWithDay(date: Date | null, locale = fr): string {
    if(date == null)
      return '';
    return format(date, 'd LLLL yyyy', {locale: this.dateGetLocale(this.translate.currentLang)});
  }
  
  dateToStringMonthYear(date: Date | null, locale = fr): string {
    if(date == null)
      return '';

    return format(date, 'MM/yyyy', {locale: this.dateGetLocale(this.translate.currentLang)});
  }

  dateToStringWithoutTimeWithDay(date: Date | null, locale = fr): string {
    if(date == null)
      return '';
    return format(date, 'EEEE d LLLL yyyy', {locale: this.dateGetLocale(this.translate.currentLang)});
  }

  dateToStringIso(date: Date | null, locale = fr): string {
    if(date == null)
      return '';
    return format(date, "yyyy-MM-dd'T'HH:mm:ssXXXXX", {locale: this.dateGetLocale(this.translate.currentLang)});
  }


  dateGetLocale(code: String) {
    if(code == 'da')
      return da;
    if(code == 'de')
      return de;
    if(code == 'en')
      return enGB;
    if(code == 'es')
      return es;
    if(code == 'fi')
      return fi;
    if(code == 'fr')
      return fr;
    if(code == 'it')
      return it;
    if(code == 'nl')
      return nl;
    if(code == 'pt')
      return pt;
    if(code == 'sv')
      return sv;
    return enGB;
  }
}
